
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class StepSectionHeader extends Vue {
  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: String })
  subtitle?: string;

  @Prop({ type: String })
  eyebrow?: string;

  @Prop({ type: String })
  helper?: string;

  @Prop({ type: String })
  badge?: string;

  @Prop({ type: String, default: 'orange lighten-5' })
  badgeColor!: string;

  @Prop({ type: String, default: 'orange darken-3' })
  badgeTextColor!: string;
}
